export const DISABLED_STORE_ITEM_STATUSES = [
  'not_available',
  'in_bag',
  'purchased',
  'future',
]

export const HTTP_STATUS = {
  NOT_AUTHORIZED: 401,
  NOT_FOUND: 404,
}

export const URLS = {
  DESIGNEDVR: 'https://designedvr.com/',
}

export const CHEKIN_SDK_CDN = {
  STAGING: 'https://cdn.chekin.com/developmentV2/ChekinPro.js',
  PRODUCTION: 'https://cdn.chekin.com/latest/ChekinPro.js',
}

export const COUNTRIES = [
  { code_2: 'AD', label: 'Andorra' },
  { code_2: 'AE', label: 'United Arab Emirates' },
  { code_2: 'AF', label: 'Afghanistan' },
  { code_2: 'AG', label: 'Antigua and Barbuda' },
  { code_2: 'AI', label: 'Anguilla' },
  { code_2: 'AL', label: 'Albania' },
  { code_2: 'AM', label: 'Armenia' },
  { code_2: 'AO', label: 'Angola' },
  { code_2: 'AQ', label: 'Antarctica' },
  { code_2: 'AR', label: 'Argentina' },
  { code_2: 'AS', label: 'American Samoa' },
  { code_2: 'AT', label: 'Austria' },
  { code_2: 'AU', label: 'Australia' },
  { code_2: 'AW', label: 'Aruba' },
  { code_2: 'AX', label: 'Åland Islands' },
  { code_2: 'AZ', label: 'Azerbaijan' },
  { code_2: 'BA', label: 'Bosnia and Herzegovina' },
  { code_2: 'BB', label: 'Barbados' },
  { code_2: 'BD', label: 'Bangladesh' },
  { code_2: 'BE', label: 'Belgium' },
  { code_2: 'BF', label: 'Burkina Faso' },
  { code_2: 'BG', label: 'Bulgaria' },
  { code_2: 'BH', label: 'Bahrain' },
  { code_2: 'BI', label: 'Burundi' },
  { code_2: 'BJ', label: 'Benin' },
  { code_2: 'BL', label: 'Saint Barthélemy' },
  { code_2: 'BM', label: 'Bermuda' },
  { code_2: 'BN', label: 'Brunei Darussalam' },
  { code_2: 'BO', label: 'Bolivia (Plurinational State of)' },
  { code_2: 'BQ', label: 'Bonaire, Sint Eustatius and Saba' },
  { code_2: 'BR', label: 'Brazil' },
  { code_2: 'BS', label: 'Bahamas' },
  { code_2: 'BT', label: 'Bhutan' },
  { code_2: 'BV', label: 'Bouvet Island' },
  { code_2: 'BW', label: 'Botswana' },
  { code_2: 'BY', label: 'Belarus' },
  { code_2: 'BZ', label: 'Belize' },
  { code_2: 'CA', label: 'Canada' },
  { code_2: 'CC', label: 'Cocos (Keeling) Islands' },
  { code_2: 'CD', label: 'Congo (Democratic Republic of the)' },
  { code_2: 'CF', label: 'Central African Republic' },
  { code_2: 'CG', label: 'Congo' },
  { code_2: 'CH', label: 'Switzerland' },
  { code_2: 'CI', label: "Côte d'Ivoire" },
  { code_2: 'CK', label: 'Cook Islands' },
  { code_2: 'CL', label: 'Chile' },
  { code_2: 'CM', label: 'Cameroon' },
  { code_2: 'CN', label: 'China' },
  { code_2: 'CO', label: 'Colombia' },
  { code_2: 'CR', label: 'Costa Rica' },
  { code_2: 'CU', label: 'Cuba' },
  { code_2: 'CV', label: 'Cabo Verde' },
  { code_2: 'CW', label: 'Curaçao' },
  { code_2: 'CX', label: 'Christmas Island' },
  { code_2: 'CY', label: 'Cyprus' },
  { code_2: 'CZ', label: 'Czechia' },
  { code_2: 'DE', label: 'Germany' },
  { code_2: 'DJ', label: 'Djibouti' },
  { code_2: 'DK', label: 'Denmark' },
  { code_2: 'DM', label: 'Dominica' },
  { code_2: 'DO', label: 'Dominican Republic' },
  { code_2: 'DZ', label: 'Algeria' },
  { code_2: 'EC', label: 'Ecuador' },
  { code_2: 'EE', label: 'Estonia' },
  { code_2: 'EG', label: 'Egypt' },
  { code_2: 'EH', label: 'Western Sahara' },
  { code_2: 'ER', label: 'Eritrea' },
  { code_2: 'ES', label: 'Spain' },
  { code_2: 'ET', label: 'Ethiopia' },
  { code_2: 'FI', label: 'Finland' },
  { code_2: 'FJ', label: 'Fiji' },
  { code_2: 'FK', label: 'Falkland Islands (Malvinas)' },
  { code_2: 'FM', label: 'Micronesia (Federated States of)' },
  { code_2: 'FO', label: 'Faroe Islands' },
  { code_2: 'FR', label: 'France' },
  { code_2: 'GA', label: 'Gabon' },
  {
    code_2: 'GB',
    label: 'United Kingdom of Great Britain and Northern Ireland',
  },
  { code_2: 'GD', label: 'Grenada' },
  { code_2: 'GE', label: 'Georgia' },
  { code_2: 'GF', label: 'French Guiana' },
  { code_2: 'GG', label: 'Guernsey' },
  { code_2: 'GH', label: 'Ghana' },
  { code_2: 'GI', label: 'Gibraltar' },
  { code_2: 'GL', label: 'Greenland' },
  { code_2: 'GM', label: 'Gambia' },
  { code_2: 'GN', label: 'Guinea' },
  { code_2: 'GP', label: 'Guadeloupe' },
  { code_2: 'GQ', label: 'Equatorial Guinea' },
  { code_2: 'GR', label: 'Greece' },
  { code_2: 'GS', label: 'South Georgia and the South Sandwich Islands' },
  { code_2: 'GT', label: 'Guatemala' },
  { code_2: 'GU', label: 'Guam' },
  { code_2: 'GW', label: 'Guinea-Bissau' },
  { code_2: 'GY', label: 'Guyana' },
  { code_2: 'HK', label: 'Hong Kong' },
  { code_2: 'HM', label: 'Heard Island and McDonald Islands' },
  { code_2: 'HN', label: 'Honduras' },
  { code_2: 'HR', label: 'Croatia' },
  { code_2: 'HT', label: 'Haiti' },
  { code_2: 'HU', label: 'Hungary' },
  { code_2: 'ID', label: 'Indonesia' },
  { code_2: 'IE', label: 'Ireland' },
  { code_2: 'IL', label: 'Israel' },
  { code_2: 'IM', label: 'Isle of Man' },
  { code_2: 'IN', label: 'India' },
  { code_2: 'IO', label: 'British Indian Ocean Territory' },
  { code_2: 'IQ', label: 'Iraq' },
  { code_2: 'IR', label: 'Iran (Islamic Republic of)' },
  { code_2: 'IS', label: 'Iceland' },
  { code_2: 'IT', label: 'Italy' },
  { code_2: 'JE', label: 'Jersey' },
  { code_2: 'JM', label: 'Jamaica' },
  { code_2: 'JO', label: 'Jordan' },
  { code_2: 'JP', label: 'Japan' },
  { code_2: 'KE', label: 'Kenya' },
  { code_2: 'KG', label: 'Kyrgyzstan' },
  { code_2: 'KH', label: 'Cambodia' },
  { code_2: 'KI', label: 'Kiribati' },
  { code_2: 'KM', label: 'Comoros' },
  { code_2: 'KN', label: 'Saint Kitts and Nevis' },
  { code_2: 'KP', label: "Korea (Democratic People's Republic of)" },
  { code_2: 'KR', label: 'Korea (Republic of)' },
  { code_2: 'KW', label: 'Kuwait' },
  { code_2: 'KY', label: 'Cayman Islands' },
  { code_2: 'KZ', label: 'Kazakhstan' },
  { code_2: 'LA', label: "Lao People's Democratic Republic" },
  { code_2: 'LB', label: 'Lebanon' },
  { code_2: 'LC', label: 'Saint Lucia' },
  { code_2: 'LI', label: 'Liechtenstein' },
  { code_2: 'LK', label: 'Sri Lanka' },
  { code_2: 'LR', label: 'Liberia' },
  { code_2: 'LS', label: 'Lesotho' },
  { code_2: 'LT', label: 'Lithuania' },
  { code_2: 'LU', label: 'Luxembourg' },
  { code_2: 'LV', label: 'Latvia' },
  { code_2: 'LY', label: 'Libya' },
  { code_2: 'MA', label: 'Morocco' },
  { code_2: 'MC', label: 'Monaco' },
  { code_2: 'MD', label: 'Moldova (Republic of)' },
  { code_2: 'ME', label: 'Montenegro' },
  { code_2: 'MF', label: 'Saint Martin (French part)' },
  { code_2: 'MG', label: 'Madagascar' },
  { code_2: 'MH', label: 'Marshall Islands' },
  { code_2: 'MK', label: 'North Macedonia' },
  { code_2: 'ML', label: 'Mali' },
  { code_2: 'MM', label: 'Myanmar' },
  { code_2: 'MN', label: 'Mongolia' },
  { code_2: 'MO', label: 'Macao' },
  { code_2: 'MP', label: 'Northern Mariana Islands' },
  { code_2: 'MQ', label: 'Martinique' },
  { code_2: 'MR', label: 'Mauritania' },
  { code_2: 'MS', label: 'Montserrat' },
  { code_2: 'MT', label: 'Malta' },
  { code_2: 'MU', label: 'Mauritius' },
  { code_2: 'MV', label: 'Maldives' },
  { code_2: 'MW', label: 'Malawi' },
  { code_2: 'MX', label: 'Mexico' },
  { code_2: 'MY', label: 'Malaysia' },
  { code_2: 'MZ', label: 'Mozambique' },
  { code_2: 'NA', label: 'Namibia' },
  { code_2: 'NC', label: 'New Caledonia' },
  { code_2: 'NE', label: 'Niger' },
  { code_2: 'NF', label: 'Norfolk Island' },
  { code_2: 'NG', label: 'Nigeria' },
  { code_2: 'NI', label: 'Nicaragua' },
  { code_2: 'NL', label: 'Netherlands' },
  { code_2: 'NO', label: 'Norway' },
  { code_2: 'NP', label: 'Nepal' },
  { code_2: 'NR', label: 'Nauru' },
  { code_2: 'NU', label: 'Niue' },
  { code_2: 'NZ', label: 'New Zealand' },
  { code_2: 'OM', label: 'Oman' },
  { code_2: 'PA', label: 'Panama' },
  { code_2: 'PE', label: 'Peru' },
  { code_2: 'PF', label: 'French Polynesia' },
  { code_2: 'PG', label: 'Papua New Guinea' },
  { code_2: 'PH', label: 'Philippines' },
  { code_2: 'PK', label: 'Pakistan' },
  { code_2: 'PL', label: 'Poland' },
  { code_2: 'PM', label: 'Saint Pierre and Miquelon' },
  { code_2: 'PN', label: 'Pitcairn' },
  { code_2: 'PR', label: 'Puerto Rico' },
  { code_2: 'PS', label: 'Palestine, State of' },
  { code_2: 'PT', label: 'Portugal' },
  { code_2: 'PW', label: 'Palau' },
  { code_2: 'PY', label: 'Paraguay' },
  { code_2: 'QA', label: 'Qatar' },
  { code_2: 'RE', label: 'Réunion' },
  { code_2: 'RO', label: 'Romania' },
  { code_2: 'RS', label: 'Serbia' },
  { code_2: 'RU', label: 'Russian Federation' },
  { code_2: 'RW', label: 'Rwanda' },
  { code_2: 'SA', label: 'Saudi Arabia' },
  { code_2: 'SB', label: 'Solomon Islands' },
  { code_2: 'SC', label: 'Seychelles' },
  { code_2: 'SD', label: 'Sudan' },
  { code_2: 'SE', label: 'Sweden' },
  { code_2: 'SG', label: 'Singapore' },
  { code_2: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha' },
  { code_2: 'SI', label: 'Slovenia' },
  { code_2: 'SJ', label: 'Svalbard and Jan Mayen' },
  { code_2: 'SK', label: 'Slovakia' },
  { code_2: 'SL', label: 'Sierra Leone' },
  { code_2: 'SM', label: 'San Marino' },
  { code_2: 'SN', label: 'Senegal' },
  { code_2: 'SO', label: 'Somalia' },
  { code_2: 'SR', label: 'Suriname' },
  { code_2: 'SS', label: 'South Sudan' },
  { code_2: 'ST', label: 'Sao Tome and Principe' },
  { code_2: 'SV', label: 'El Salvador' },
  { code_2: 'SX', label: 'Sint Maarten (Dutch part)' },
  { code_2: 'SY', label: 'Syrian Arab Republic' },
  { code_2: 'SZ', label: 'Eswatini' },
  { code_2: 'TC', label: 'Turks and Caicos Islands' },
  { code_2: 'TD', label: 'Chad' },
  { code_2: 'TF', label: 'French Southern Territories' },
  { code_2: 'TG', label: 'Togo' },
  { code_2: 'TH', label: 'Thailand' },
  { code_2: 'TJ', label: 'Tajikistan' },
  { code_2: 'TK', label: 'Tokelau' },
  { code_2: 'TL', label: 'Timor-Leste' },
  { code_2: 'TM', label: 'Turkmenistan' },
  { code_2: 'TN', label: 'Tunisia' },
  { code_2: 'TO', label: 'Tonga' },
  { code_2: 'TR', label: 'Turkey' },
  { code_2: 'TT', label: 'Trinidad and Tobago' },
  { code_2: 'TV', label: 'Tuvalu' },
  { code_2: 'TW', label: 'Taiwan, Province of China' },
  { code_2: 'TZ', label: 'Tanzania, United Republic of' },
  { code_2: 'UA', label: 'Ukraine' },
  { code_2: 'UG', label: 'Uganda' },
  { code_2: 'UM', label: 'United States Minor Outlying Islands' },
  { code_2: 'US', label: 'United States of America' },
  { code_2: 'UY', label: 'Uruguay' },
  { code_2: 'UZ', label: 'Uzbekistan' },
  { code_2: 'VA', label: 'Holy See' },
  { code_2: 'VC', label: 'Saint Vincent and the Grenadines' },
  { code_2: 'VE', label: 'Venezuela (Bolivarian Republic of)' },
  { code_2: 'VG', label: 'Virgin Islands (British)' },
  { code_2: 'VI', label: 'Virgin Islands (U.S.)' },
  { code_2: 'VN', label: 'Viet Nam' },
  { code_2: 'VU', label: 'Vanuatu' },
  { code_2: 'WF', label: 'Wallis and Futuna' },
  { code_2: 'WS', label: 'Samoa' },
  { code_2: 'YE', label: 'Yemen' },
  { code_2: 'YT', label: 'Mayotte' },
  { code_2: 'ZA', label: 'South Africa' },
  { code_2: 'ZM', label: 'Zambia' },
  { code_2: 'ZW', label: 'Zimbabwe' },
]

export const US_STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
  DC: 'District of Columbia',
}

export const CA_PROVINCES = {
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  NS: 'Nova Scotia',
  NT: 'Northwest Territories',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Quebec',
  SK: 'Saskatchewan',
  YT: 'Yukon',
}

export const AU_STATES = {
  ACT: 'Australian Capital Territory',
  NSW: 'New South Wales',
  NT: 'Northern Territory',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  VIC: 'Victoria',
  WA: 'Western Australia',
}
